/**
* @Author: 858834013@qq.com
* @Name: 实时信息
* @Date: 2022-08-16
* @Desc:实时信息
*/
<template>
  <div>
    <div @click="getShow" class="cur">
      <slot></slot>
    </div>
    <TinyLayer
      v-model="layerVisible"
      :header-visible="false"
      :footer-visible="false"
      class-name="newPopWin"
      :body-scrollable="false"
      width="520"
      content-background="rgba(0,0,0,0)"
      background="rgba(0,0,0,0)"
      mask-background="rgba(0, 22, 120, 0.9)"
      mask-closable
    >
      <div class="popWin">
        <div class="popWinBody">
          <div class="close" @click="getHide">
            <img src="../../../assets/home/icon_close2.png" alt="">
          </div>
          <titleInfo title="实时信息"></titleInfo>
          <div class="popWinMain">
            <div class="popWinMainLeft">
              <p><em>设备名称:</em> <span>武警携行箱01</span></p>
              <p><em>设备状态: </em><span class="status">开箱</span></p>
              <p><em>信号强度: </em> <span class="status2">20%</span></p>
              <p><em><b>电</b><b>量:</b></em><span class="status2">80%</span></p>
              <p><em>开箱地点: </em><span>上海市长宁区环绿路</span></p>
              <p><em>上报时间: </em><span>2021-10-26 11:45:00</span></p>
            </div>
            <div class="popWinMainRight">
              <div class="userHeadInfo">
                <img src="../../../assets/home/tupian1.png" alt="">
                <div class="zhezhao1"></div>
              </div>
              <div class="userHeadInfo">
                <img src="../../../assets/home/tupian1.png" alt="">
                <div class="zhezhao2"></div>
              </div>
            </div>
          </div>
          <div class="line">
            <img src="../../../assets/home/icon_line4.png" alt="">
          </div>
          <div class="operation">
            <div class="cancel">轨迹回放</div>
            <div class="confirm" @click="getHide">确定</div>
          </div>
        </div>
      </div>
    </TinyLayer>
  </div>
</template>

<script>
import TinyLayer from "tinylayer";
import titleInfo from "@/components/titleInfo";

export default {
  name: "message",
  components: {TinyLayer, titleInfo},
  props: {
    id: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      newIpAddress: '',
      layerVisible: false
    }
  },
  watch: {},
  mounted() {
  },
  methods: {

    getShow() {
      this.layerVisible = true
    },
    getHide() {
      this.layerVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.popWin {
  width: 518px;
  height: 503px;
  background: url("../../../assets/home/item6_popbg1.png") no-repeat;
  background-size: 100% 100%;
}

.operation {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  align-content: flex-start;
  margin-top: 10px;

  .cancel {
    width: 120px;
    height: 38px;
    background: #FFFFFF;
    background: url("../../../assets/home/item_but1.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
    align-content: flex-start;
    font-size: 18px;
    font-family: PingFang;
    cursor: pointer;
    font-weight: 500;
    color: #FFFFFF;
    margin-right: 70px;
  }

  .confirm {
    width: 120px;
    height: 38px;
    margin-left: 70px;
    background: #FFFFFF;
    background: url("../../../assets/home/item_but1.png") no-repeat;
    display: flex;
    justify-content: center;
    background-size: 100% 100%;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
    align-content: flex-start;
    font-size: 18px;
    font-family: PingFang;
    font-weight: 500;
    color: #FFFFFF;
    cursor: pointer;
  }

  .cancel:hover, .confirm:hover {
    opacity: 0.7;
  }

  .line {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
    align-content: flex-start;

    img {
      width: 456px;
      height: 1px;
    }
  }
}

.popWinMain {
  margin-top: 0px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  align-content: flex-start;

  .popWinMainLeft {
    margin-top: 40px;

    p {
      font-size: 14px;
      font-family: PingFang;
      font-weight: 500;
      color: rgba(#01A3FF, 0.6);
      margin-left: 30px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      flex-direction: row;
      align-content: flex-start;
      height: 50px;

      em {
        font-style: normal;
        margin-right: 10px;
        width: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: nowrap;
        flex-direction: row;
        align-content: flex-start;
      }

      span {
        font-size: 14px;
        font-family: PingFang;
        font-weight: 500;
        color: #CDF7FF;
      }

      .status {
        font-size: 16px;
        font-family: PingFang;
        font-weight: 500;
        color: #99DCFE;
        width: 54px;
        height: 26px;
        background: rgba(70, 188, 255, 0.3);
        border: 1px solid #46BCFF;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: nowrap;
        flex-direction: row;
        align-content: flex-start;
      }

      .status2 {
        color: rgba(255, 215, 74, 1);
      }
    }
  }

  .popWinMainRight {
    margin-right: 30px;
  }
}

.popWinBody {
  margin-left: 20px;
  padding-top: 10px;
}

.userHeadInfo {
  position: relative;
  width: 137px;
  margin-bottom: 20px;

  img {
    border-radius: 15px 15px 0 0;
    width: 137px;
    height: 157px;
  }

  .zhezhao1 {
    background: url("../../../assets/home/photoFrame1.png");
    width: 137px;
    height: 159px;
    background-size: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .zhezhao2 {
    background: url("../../../assets/home/photoFrame2.png");
    width: 137px;
    height: 159px;
    background-size: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
}

.close {
  position: absolute;
  right: 15px;
  top: 15px;
  cursor: pointer;
  img{
    width: 20px;
    height: 20px;
  }
}
</style>
